import React from 'react';
import {Forms} from  './Forms/'

export const DhsPage = () => {
  return <Forms/>
};

